module.exports = __webpack_public_path__ + "static/media/bg-image-1.ee554567.jpg";